// tslint:disable
/**
 * Commissions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface CommissionScheduleDto
 */
export interface CommissionScheduleDto {
    /**
     * 
     * @type {string}
     * @memberof CommissionScheduleDto
     */
    agentNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommissionScheduleDto
     */
    agentName?: string | null;
    /**
     * 
     * @type {Array<CommissionScheduleTypeDto>}
     * @memberof CommissionScheduleDto
     */
    types?: Array<CommissionScheduleTypeDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CommissionScheduleDto
     */
    contract?: string | null;
    /**
     * 
     * @type {Source}
     * @memberof CommissionScheduleDto
     */
    source?: Source | null;
}
/**
 * 
 * @export
 * @interface CommissionScheduleTypeDto
 */
export interface CommissionScheduleTypeDto {
    /**
     * 
     * @type {string}
     * @memberof CommissionScheduleTypeDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommissionScheduleTypeDto
     */
    type?: string | null;
    /**
     * 
     * @type {Link}
     * @memberof CommissionScheduleTypeDto
     */
    link?: Link | null;
}
/**
 * 
 * @export
 * @interface CommissionStatementDto
 */
export interface CommissionStatementDto {
    /**
     * 
     * @type {string}
     * @memberof CommissionStatementDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommissionStatementDto
     */
    agentNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommissionStatementDto
     */
    agentName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CommissionStatementDto
     */
    statementDate?: Date;
    /**
     * 
     * @type {Source}
     * @memberof CommissionStatementDto
     */
    source?: Source | null;
    /**
     * 
     * @type {string}
     * @memberof CommissionStatementDto
     */
    documentId?: string | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof CommissionStatementDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface Enumeration
 */
export interface Enumeration {
    /**
     * 
     * @type {string}
     * @memberof Enumeration
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Enumeration
     */
    id?: number;
}
/**
 * 
 * @export
 * @interface Link
 */
export interface Link {
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    href?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    rel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    verb?: string | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfCommissionScheduleDto
 */
export interface PagedResultOfCommissionScheduleDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfCommissionScheduleDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfCommissionScheduleDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<CommissionScheduleDto>}
     * @memberof PagedResultOfCommissionScheduleDto
     */
    result?: Array<CommissionScheduleDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfCommissionScheduleDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfCommissionStatementDto
 */
export interface PagedResultOfCommissionStatementDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfCommissionStatementDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfCommissionStatementDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<CommissionStatementDto>}
     * @memberof PagedResultOfCommissionStatementDto
     */
    result?: Array<CommissionStatementDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfCommissionStatementDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfTaxStatementDto
 */
export interface PagedResultOfTaxStatementDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfTaxStatementDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfTaxStatementDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<TaxStatementDto>}
     * @memberof PagedResultOfTaxStatementDto
     */
    result?: Array<TaxStatementDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfTaxStatementDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface ProcessLogDto
 */
export interface ProcessLogDto {
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    processName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    machineName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ProcessLogDto
     */
    etlLoadStartDateTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProcessLogDto
     */
    etlLoadEndDateTime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    elapsedTime?: string | null;
}
/**
 * 
 * @export
 * @interface Source
 */
export interface Source extends Enumeration {
}
/**
 * 
 * @export
 * @interface TaxFormType
 */
export interface TaxFormType extends Enumeration {
}
/**
 * 
 * @export
 * @interface TaxStatementDto
 */
export interface TaxStatementDto {
    /**
     * 
     * @type {string}
     * @memberof TaxStatementDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaxStatementDto
     */
    accountNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaxStatementDto
     */
    accountName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaxStatementDto
     */
    taxYear?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaxStatementDto
     */
    encryptedIdentifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaxStatementDto
     */
    maskedIdentifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaxStatementDto
     */
    history?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaxStatementDto
     */
    documentId?: string | null;
    /**
     * 
     * @type {TaxFormType}
     * @memberof TaxStatementDto
     */
    taxFormType?: TaxFormType | null;
    /**
     * 
     * @type {Source}
     * @memberof TaxStatementDto
     */
    source?: Source | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof TaxStatementDto
     */
    links?: Array<Link> | null;
}

/**
 * AdvancedStatementApi - axios parameter creator
 * @export
 */
export const AdvancedStatementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEarnedCommissionDocument(id: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getEarnedCommissionDocument.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getEarnedCommissionDocument.');
            }
            const localVarPath = `/api/v{version}/commissions/advancedStatements/{id}/document`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAdvancedCommissions(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling searchAdvancedCommissions.');
            }
            const localVarPath = `/api/v{version}/commissions/advancedStatements`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdvancedStatementApi - functional programming interface
 * @export
 */
export const AdvancedStatementApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEarnedCommissionDocument(id: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = AdvancedStatementApiAxiosParamCreator(configuration).getEarnedCommissionDocument(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAdvancedCommissions(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfCommissionStatementDto> {
            const localVarAxiosArgs = AdvancedStatementApiAxiosParamCreator(configuration).searchAdvancedCommissions(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AdvancedStatementApi - factory interface
 * @export
 */
export const AdvancedStatementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEarnedCommissionDocument(id: string, version: string, options?: any): AxiosPromise<string> {
            return AdvancedStatementApiFp(configuration).getEarnedCommissionDocument(id, version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAdvancedCommissions(version: string, options?: any): AxiosPromise<PagedResultOfCommissionStatementDto> {
            return AdvancedStatementApiFp(configuration).searchAdvancedCommissions(version, options)(axios, basePath);
        },
    };
};

/**
 * AdvancedStatementApi - object-oriented interface
 * @export
 * @class AdvancedStatementApi
 * @extends {BaseAPI}
 */
export class AdvancedStatementApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvancedStatementApi
     */
    public getEarnedCommissionDocument(id: string, version: string, options?: any) {
        return AdvancedStatementApiFp(this.configuration).getEarnedCommissionDocument(id, version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvancedStatementApi
     */
    public searchAdvancedCommissions(version: string, options?: any) {
        return AdvancedStatementApiFp(this.configuration).searchAdvancedCommissions(version, options)(this.axios, this.basePath);
    }

}


/**
 * CommissionsApi - axios parameter creator
 * @export
 */
export const CommissionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {number} [sourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commissionsCommissionsETL(version: string, sourceId?: number, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling commissionsCommissionsETL.');
            }
            const localVarPath = `/api/v{version}/commissions/statements/etl`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (sourceId !== undefined) {
                localVarQueryParameter['sourceId'] = sourceId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commissionsCommissionsETLReset(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling commissionsCommissionsETLReset.');
            }
            const localVarPath = `/api/v{version}/commissions/etl/reset`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {number} [sourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commissionsTaxStatementsETL(version: string, sourceId?: number, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling commissionsTaxStatementsETL.');
            }
            const localVarPath = `/api/v{version}/commissions/taxstatements/etl`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (sourceId !== undefined) {
                localVarQueryParameter['sourceId'] = sourceId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commissionsTaxStatementsETLReset(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling commissionsTaxStatementsETLReset.');
            }
            const localVarPath = `/api/v{version}/commissions/taxstatements/etl/reset`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommissionsApi - functional programming interface
 * @export
 */
export const CommissionsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {number} [sourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commissionsCommissionsETL(version: string, sourceId?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = CommissionsApiAxiosParamCreator(configuration).commissionsCommissionsETL(version, sourceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commissionsCommissionsETLReset(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = CommissionsApiAxiosParamCreator(configuration).commissionsCommissionsETLReset(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {number} [sourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commissionsTaxStatementsETL(version: string, sourceId?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = CommissionsApiAxiosParamCreator(configuration).commissionsTaxStatementsETL(version, sourceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commissionsTaxStatementsETLReset(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = CommissionsApiAxiosParamCreator(configuration).commissionsTaxStatementsETLReset(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CommissionsApi - factory interface
 * @export
 */
export const CommissionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {number} [sourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commissionsCommissionsETL(version: string, sourceId?: number, options?: any): AxiosPromise<void> {
            return CommissionsApiFp(configuration).commissionsCommissionsETL(version, sourceId, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commissionsCommissionsETLReset(version: string, options?: any): AxiosPromise<void> {
            return CommissionsApiFp(configuration).commissionsCommissionsETLReset(version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {number} [sourceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commissionsTaxStatementsETL(version: string, sourceId?: number, options?: any): AxiosPromise<void> {
            return CommissionsApiFp(configuration).commissionsTaxStatementsETL(version, sourceId, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commissionsTaxStatementsETLReset(version: string, options?: any): AxiosPromise<void> {
            return CommissionsApiFp(configuration).commissionsTaxStatementsETLReset(version, options)(axios, basePath);
        },
    };
};

/**
 * CommissionsApi - object-oriented interface
 * @export
 * @class CommissionsApi
 * @extends {BaseAPI}
 */
export class CommissionsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {number} [sourceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommissionsApi
     */
    public commissionsCommissionsETL(version: string, sourceId?: number, options?: any) {
        return CommissionsApiFp(this.configuration).commissionsCommissionsETL(version, sourceId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommissionsApi
     */
    public commissionsCommissionsETLReset(version: string, options?: any) {
        return CommissionsApiFp(this.configuration).commissionsCommissionsETLReset(version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {number} [sourceId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommissionsApi
     */
    public commissionsTaxStatementsETL(version: string, sourceId?: number, options?: any) {
        return CommissionsApiFp(this.configuration).commissionsTaxStatementsETL(version, sourceId, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommissionsApi
     */
    public commissionsTaxStatementsETLReset(version: string, options?: any) {
        return CommissionsApiFp(this.configuration).commissionsTaxStatementsETLReset(version, options)(this.axios, this.basePath);
    }

}


/**
 * DocumentsApi - axios parameter creator
 * @export
 */
export const DocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsGet(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling documentsGet.');
            }
            const localVarPath = `/api/v{version}/commissions/documents/commissionDirectDepositAuthorizationForm`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentsApi - functional programming interface
 * @export
 */
export const DocumentsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsGet(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = DocumentsApiAxiosParamCreator(configuration).documentsGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DocumentsApi - factory interface
 * @export
 */
export const DocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsGet(version: string, options?: any): AxiosPromise<string> {
            return DocumentsApiFp(configuration).documentsGet(version, options)(axios, basePath);
        },
    };
};

/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
export class DocumentsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public documentsGet(version: string, options?: any) {
        return DocumentsApiFp(this.configuration).documentsGet(version, options)(this.axios, this.basePath);
    }

}


/**
 * EarnedStatementsApi - axios parameter creator
 * @export
 */
export const EarnedStatementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEarnedCommissionDocument2(id: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getEarnedCommissionDocument2.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getEarnedCommissionDocument2.');
            }
            const localVarPath = `/api/v{version}/commissions/earnedStatements/{id}/document`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEarnedCommissions(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling searchEarnedCommissions.');
            }
            const localVarPath = `/api/v{version}/commissions/earnedStatements`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EarnedStatementsApi - functional programming interface
 * @export
 */
export const EarnedStatementsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEarnedCommissionDocument2(id: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = EarnedStatementsApiAxiosParamCreator(configuration).getEarnedCommissionDocument2(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEarnedCommissions(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfCommissionStatementDto> {
            const localVarAxiosArgs = EarnedStatementsApiAxiosParamCreator(configuration).searchEarnedCommissions(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EarnedStatementsApi - factory interface
 * @export
 */
export const EarnedStatementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEarnedCommissionDocument2(id: string, version: string, options?: any): AxiosPromise<string> {
            return EarnedStatementsApiFp(configuration).getEarnedCommissionDocument2(id, version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEarnedCommissions(version: string, options?: any): AxiosPromise<PagedResultOfCommissionStatementDto> {
            return EarnedStatementsApiFp(configuration).searchEarnedCommissions(version, options)(axios, basePath);
        },
    };
};

/**
 * EarnedStatementsApi - object-oriented interface
 * @export
 * @class EarnedStatementsApi
 * @extends {BaseAPI}
 */
export class EarnedStatementsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EarnedStatementsApi
     */
    public getEarnedCommissionDocument2(id: string, version: string, options?: any) {
        return EarnedStatementsApiFp(this.configuration).getEarnedCommissionDocument2(id, version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EarnedStatementsApi
     */
    public searchEarnedCommissions(version: string, options?: any) {
        return EarnedStatementsApiFp(this.configuration).searchEarnedCommissions(version, options)(this.axios, this.basePath);
    }

}


/**
 * HeartbeatApi - axios parameter creator
 * @export
 */
export const HeartbeatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatGet(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling heartbeatGet.');
            }
            const localVarPath = `/api/v{version}/commissions/heartbeat`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HeartbeatApi - functional programming interface
 * @export
 */
export const HeartbeatApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatGet(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = HeartbeatApiAxiosParamCreator(configuration).heartbeatGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * HeartbeatApi - factory interface
 * @export
 */
export const HeartbeatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatGet(version: string, options?: any): AxiosPromise<void> {
            return HeartbeatApiFp(configuration).heartbeatGet(version, options)(axios, basePath);
        },
    };
};

/**
 * HeartbeatApi - object-oriented interface
 * @export
 * @class HeartbeatApi
 * @extends {BaseAPI}
 */
export class HeartbeatApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HeartbeatApi
     */
    public heartbeatGet(version: string, options?: any) {
        return HeartbeatApiFp(this.configuration).heartbeatGet(version, options)(this.axios, this.basePath);
    }

}


/**
 * ProcessLogsApi - axios parameter creator
 * @export
 */
export const ProcessLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEtlStatuses(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getLatestEtlStatuses.');
            }
            const localVarPath = `/api/v{version}/commissions/processlogs/latest`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessLogsApi - functional programming interface
 * @export
 */
export const ProcessLogsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEtlStatuses(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcessLogDto>> {
            const localVarAxiosArgs = ProcessLogsApiAxiosParamCreator(configuration).getLatestEtlStatuses(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProcessLogsApi - factory interface
 * @export
 */
export const ProcessLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEtlStatuses(version: string, options?: any): AxiosPromise<Array<ProcessLogDto>> {
            return ProcessLogsApiFp(configuration).getLatestEtlStatuses(version, options)(axios, basePath);
        },
    };
};

/**
 * ProcessLogsApi - object-oriented interface
 * @export
 * @class ProcessLogsApi
 * @extends {BaseAPI}
 */
export class ProcessLogsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessLogsApi
     */
    public getLatestEtlStatuses(version: string, options?: any) {
        return ProcessLogsApiFp(this.configuration).getLatestEtlStatuses(version, options)(this.axios, this.basePath);
    }

}


/**
 * SchedulesApi - axios parameter creator
 * @export
 */
export const SchedulesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedule(id: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getSchedule.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getSchedule.');
            }
            const localVarPath = `/api/v{version}/commissions/schedules/{id}/document`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulesSchedulesETLReset(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling schedulesSchedulesETLReset.');
            }
            const localVarPath = `/api/v{version}/commissions/schedules/etl`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCommissionSchedules(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling searchCommissionSchedules.');
            }
            const localVarPath = `/api/v{version}/commissions/schedules`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchedulesApi - functional programming interface
 * @export
 */
export const SchedulesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedule(id: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = SchedulesApiAxiosParamCreator(configuration).getSchedule(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulesSchedulesETLReset(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = SchedulesApiAxiosParamCreator(configuration).schedulesSchedulesETLReset(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCommissionSchedules(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfCommissionScheduleDto> {
            const localVarAxiosArgs = SchedulesApiAxiosParamCreator(configuration).searchCommissionSchedules(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SchedulesApi - factory interface
 * @export
 */
export const SchedulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedule(id: string, version: string, options?: any): AxiosPromise<string> {
            return SchedulesApiFp(configuration).getSchedule(id, version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schedulesSchedulesETLReset(version: string, options?: any): AxiosPromise<void> {
            return SchedulesApiFp(configuration).schedulesSchedulesETLReset(version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCommissionSchedules(version: string, options?: any): AxiosPromise<PagedResultOfCommissionScheduleDto> {
            return SchedulesApiFp(configuration).searchCommissionSchedules(version, options)(axios, basePath);
        },
    };
};

/**
 * SchedulesApi - object-oriented interface
 * @export
 * @class SchedulesApi
 * @extends {BaseAPI}
 */
export class SchedulesApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulesApi
     */
    public getSchedule(id: string, version: string, options?: any) {
        return SchedulesApiFp(this.configuration).getSchedule(id, version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulesApi
     */
    public schedulesSchedulesETLReset(version: string, options?: any) {
        return SchedulesApiFp(this.configuration).schedulesSchedulesETLReset(version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchedulesApi
     */
    public searchCommissionSchedules(version: string, options?: any) {
        return SchedulesApiFp(this.configuration).searchCommissionSchedules(version, options)(this.axios, this.basePath);
    }

}


/**
 * TaxStatementsApi - axios parameter creator
 * @export
 */
export const TaxStatementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxStatement(id: string, version: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getTaxStatement.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getTaxStatement.');
            }
            const localVarPath = `/api/v{version}/commissions/taxStatements/{id}/document`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTaxStatements(version: string, options: any = {}): RequestArgs {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling searchTaxStatements.');
            }
            const localVarPath = `/api/v{version}/commissions/taxStatements`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaxStatementsApi - functional programming interface
 * @export
 */
export const TaxStatementsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxStatement(id: string, version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = TaxStatementsApiAxiosParamCreator(configuration).getTaxStatement(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTaxStatements(version: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfTaxStatementDto> {
            const localVarAxiosArgs = TaxStatementsApiAxiosParamCreator(configuration).searchTaxStatements(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TaxStatementsApi - factory interface
 * @export
 */
export const TaxStatementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxStatement(id: string, version: string, options?: any): AxiosPromise<string> {
            return TaxStatementsApiFp(configuration).getTaxStatement(id, version, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTaxStatements(version: string, options?: any): AxiosPromise<PagedResultOfTaxStatementDto> {
            return TaxStatementsApiFp(configuration).searchTaxStatements(version, options)(axios, basePath);
        },
    };
};

/**
 * TaxStatementsApi - object-oriented interface
 * @export
 * @class TaxStatementsApi
 * @extends {BaseAPI}
 */
export class TaxStatementsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxStatementsApi
     */
    public getTaxStatement(id: string, version: string, options?: any) {
        return TaxStatementsApiFp(this.configuration).getTaxStatement(id, version, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxStatementsApi
     */
    public searchTaxStatements(version: string, options?: any) {
        return TaxStatementsApiFp(this.configuration).searchTaxStatements(version, options)(this.axios, this.basePath);
    }

}


